import {Canvas, Circle, Path} from "fabric";

export function createTextCirclePath(canvasSize: number, radius: number, clockwise: boolean) {
    // SVG path using two arcs to create a full circle
    let path;
    if (clockwise) {
        path = `M ${canvasSize / 2 - radius}, ${canvasSize / 2}
                a ${radius},${radius} 0 1,1 ${radius * 2},0
                a ${radius},${radius} 0 1,1 ${-radius * 2},0`;
    } else {
        path = `M ${canvasSize / 2 - radius}, ${canvasSize / 2}
                a ${radius},${radius} 0 1,0 ${radius * 2},0
                a ${radius},${radius} 0 1,0 ${-radius * 2},0`;
    }

    return new Path(path, {
        fill: '',           // or 'transparent' - removes the black fill
        stroke: '',         // removes any stroke/border
        opacity: 0,          // makes it invisible (optional, for extra safety)
    });
}

//N.B.: Fabric.js/SVG angles are in degrees. 0 is at 3 o'clock.
export function createTextBackgroundPath(canvasSize: number, outerRadius: number, innerRadius: number, startAngle: number, angleLength: number, clockwise: boolean) {

    const center = canvasSize / 2;
    const degToRad = Math.PI / 180;

    // Step 1: Set first position on the outer circle
    const startRad = startAngle * degToRad;
    const x1 = center + outerRadius * Math.cos(startRad);
    const y1 = center + outerRadius * Math.sin(startRad);

    // Step 2: Move on an arc of angleLength
    // For anti-clockwise, we subtract the angle. For clockwise, we add it.
    const sweepFlag = clockwise ? 1 : 0;
    const endAngle = clockwise ? startAngle + angleLength : startAngle - angleLength;
    const endRad = endAngle * degToRad;

    const x2 = center + outerRadius * Math.cos(endRad);
    const y2 = center + outerRadius * Math.sin(endRad);

    // Step 3: Move to inner radius
    const x3 = center + innerRadius * Math.cos(endRad);
    const y3 = center + innerRadius * Math.sin(endRad);

    // Step 4: Move on an arc in the opposite direction
    const x4 = center + innerRadius * Math.cos(startRad);
    const y4 = center + innerRadius * Math.sin(startRad);

    const largeArcFlag = angleLength > 180 ? 1 : 0;
    const reverseSweepFlag = clockwise ? 0 : 1;

    let path = `M ${x1} ${y1} 
                A ${outerRadius} ${outerRadius} 0 ${largeArcFlag} ${sweepFlag} ${x2} ${y2}
                L ${x3} ${y3}
                A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} ${reverseSweepFlag} ${x4} ${y4}
                Z`;

    return new Path(path);
}

export function computeClipPath(
    radius: number,
    imageScale: number,
) {
    return new Circle({
        radius: radius / imageScale,
    });
}

// TODO: export max width/height of the original image if smaller than the canvas
// or scale the canvas
export function exportImage(canvas?: Canvas) {
    if (!canvas) return;

    const objectsBB = getBoundingBox(canvas);

    const imageSrc = canvas.toDataURL(
        {
            multiplier: 1,
            ...objectsBB
        }
    );

    const a = document.createElement('a');
    a.href = imageSrc;
    a.download = 'IBuyFromEU.png';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

function getBoundingBox(canvas: Canvas) {
    let top = canvas.getHeight(); // to be decreased by Math.min calls
    let left = canvas.getWidth(); // idem
    let height = 0; // to be increased by Math.min calls
    let width = 0; // idem

    canvas.getObjects().forEach(function (o) {
        const boundingRect = o.getBoundingRect();

        top = Math.min(top, Math.max(0, boundingRect.top));
        left = Math.min(top, Math.max(0, boundingRect.left));
        height = Math.max(height, Math.min(canvas.getHeight(), boundingRect.height + Math.max(0, boundingRect.top - top)));
        width = Math.max(width, Math.min(canvas.getWidth(), boundingRect.width + Math.max(0, boundingRect.left - left)));
    });

    return {
        top: top,
        left: left,
        height: height,
        width: width,
    }
}